import { createContext, useContext, ReactNode } from 'react';

interface DetectionContextType {
  startDetection: () => void;
  stopDetection: () => void;
  isDetecting: boolean;
}

const DetectionContext = createContext<DetectionContextType | undefined>(undefined);

export function useDetection() {
  const context = useContext(DetectionContext);
  if (context === undefined) {
    throw new Error('useDetection must be used within a DetectionProvider');
  }
  return context;
}

interface DetectionProviderProps {
  children: ReactNode;
  startDetection: () => void;
  stopDetection: () => void;
  isDetecting: boolean;
}

export function DetectionProvider({ children, startDetection, stopDetection, isDetecting }: DetectionProviderProps) {
  return (
    <DetectionContext.Provider value={{ startDetection, stopDetection, isDetecting }}>
      {children}
    </DetectionContext.Provider>
  );
}